const CreateAccountCtaMap = new Map();

CreateAccountCtaMap.set(
  "_default",
  "https://merchant.cashfree.com/merchants/signup?source-action=Home%20page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "woocommerce-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=Woocommerce%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "magento-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=Magento%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "send-money-to-india/global-payouts",
  "https://merchant.cashfree.com/merchants/signup?source-action=global%20payouts%20lp&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "shopify-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=Shopify%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=PG%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "payouts",
  "https://merchant.cashfree.com/merchants/signup?source-action=Payout%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "payment-forms",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20forms&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "payment-links",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20links&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "soft-pos",
  "https://merchant.cashfree.com/merchants/signup?source-action=softpos&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "PAN-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=PAN%20Verification%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "aadhaar-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=aadhaar%20verification&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "card-tokenization",
  "https://merchant.cashfree.com/merchants/signup?source-action=tokenvault&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "cred",
  "https://merchant.cashfree.com/merchants/signup?source-action=CRED%20Case%20Study&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "ritu-kumar",
  "https://merchant.cashfree.com/merchants/signup?source-action=RituKumar%20Case%20Study&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "gst-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=gstin%20verification&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "working-capital-loan",
  "https://merchant.cashfree.com/merchants/signup?source-action=Advances%20page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "wix-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=wix%20payment%20gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "report-socialmedia-issue",
  "https://merchant.cashfree.com/merchants/signup?source-action=Social%20Media%ReportPage&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "events",
  "https://merchant.cashfree.com/merchants/signup?source-action=Events%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "card-issuance",
  "https://merchant.cashfree.com/merchants/signup?source-action=card%20issuance&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "upi-qr-code",
  "https://merchant.cashfree.com/merchants/signup?source-action=upi%20qr%20code&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "upi-autopay",
  "https://merchant.cashfree.com/merchants/signup?source-action=upi%20autopay&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "cashgram",
  "https://merchant.cashfree.com/merchants/signup?source-action=Cashgram%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "instant-settlements",
  "https://merchant.cashfree.com/merchants/signup?source-action=Instant%20settlements&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "easy-split",
  "https://merchant.cashfree.com/merchants/signup?source-action=easy%20split&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "buy-now-pay-later",
  "https://merchant.cashfree.com/merchants/signup?source-action=BNPL&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "yes-bank-cashfree",
  "https://merchant.cashfree.com/merchants/signup?source-action=Yes%20Bank%20CFWebinar&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "international-wire-transfer",
  "https://merchant.cashfree.com/merchants/signup?source-action=international%20wire%20transfer&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "embedded-lending",
  "https://merchant.cashfree.com/merchants/signup?source-action=Embedded%20lending&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "api-banking-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=API%20banking%20India&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "grievance-redressal-policy",
  "https://merchant.cashfree.com/merchants/signup?source-action=grievance%20redressal&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "outward-remittance",
  "https://merchant.cashfree.com/merchants/signup?source-action=Outward%20remittance&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "partner-program",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=partner%20program&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "recurring-payment",
  "https://merchant.cashfree.com/merchants/signup?source-action=Subscriptions%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "connected-banking",
  "https://merchant.cashfree.com/merchants/signup?source-action=Connected%20Banking&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "enach",
  "https://merchant.cashfree.com/merchants/signup?source-action=eNACH&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "kyc-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Verification%20Suite&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "shopify-signup",
  "https://merchant.cashfree.com/merchants/signup?source-action=Shopify%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "bank-account-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=BAV%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "nbfc",
  "https://merchant.cashfree.com/merchants/signup?source-action=NBFC%20lending%20solution&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "upi-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=UPI%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "ecommerce-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=ecommerce%20lp&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "white-label-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=WhiteLabel%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "case-study",
  "https://merchant.cashfree.com/merchants/signup?source-action=CaseStudy%20Home&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "education",
  "https://merchant.cashfree.com/merchants/signup?source-action=Solutions%20Education&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "partner-integration",
  "https://merchant.cashfree.com/merchants/signup?source-action=Partner%20Integration&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "virtual-payment-address",
  "https://merchant.cashfree.com/merchants/signup?source-action=auto%collect%VPA&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "support",
  "https://merchant.cashfree.com/merchants/signup?source-action=Support%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "payment-links",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20links&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "about-us",
  "https://merchant.cashfree.com/merchants/signup?source-action=About%20Us&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "payment-gateway-charges",
  "https://merchant.cashfree.com/merchants/signup?source-action=Pricing%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "bnpl-plus",
  "https://merchant.cashfree.com/merchants/signup?source-action=BNPL%20Plus&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "online-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Online%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "freelancer-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Freelancer%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "vendor-payments",
  "https://merchant.cashfree.com/merchants/signup?source-action=Vendor%20Payments&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "debit-card-emi",
  "https://merchant.cashfree.com/merchants/signup?source-action=Debit%20Card%20EMI&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "embedded-payments",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=Embedded%20Payments&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "escrow-account",
  "https://merchant.cashfree.com/merchants/signup?source-action=One%20Escrow&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "privacypolicy",
  "https://merchant.cashfree.com/merchants/signup?source-action=Privacy%20Policy&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "paymentservices_tnc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Payment%20Services%20TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "tnc",
  "https://merchant.cashfree.com/merchants/signup?source-action=TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "settlement-and-reconciliation-guide",
  "https://merchant.cashfree.com/merchants/signup?source-action=Settlement%20Reconciliation%20Guide&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "whitepapers/optimizing-transaction-success-rate",
  "https://merchant.cashfree.com/merchants/signup?source-action=hsr%20ebook&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "banking-as-a-service",
  "https://merchant.cashfree.com/merchants/signup?source-action=banking%20as%20a%20service&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "preauthorization",
  "https://merchant.cashfree.com/merchants/signup?source-action=Pre%20Auth&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "auto-e-collect",
  "https://merchant.cashfree.com/merchants/signup?source-action=Autocollect%20Page&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "startups",
  "https://merchant.cashfree.com/merchants/signup?source-action=OutoftheWorld&action=Sign%20Up&button-id=StartNow_NavBar",
);
CreateAccountCtaMap.set(
  "instant-refunds",
  "https://merchant.cashfree.com/merchants/signup?source-action=Instant%20Refund&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "kyc-link",
  "https://merchant.cashfree.com/merchants/signup?source-action=kyc%20link&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "bbps-biller",
  "https://merchant.cashfree.com/merchants/signup",
);
CreateAccountCtaMap.set(
  "cb-partner-solutions/global-trade-plaza",
  "https://merchant.cashfree.com/merchants/signup?source-action=PartnerSolution%20CB%20GTP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "accelerated-onboarding",
  "https://merchant.cashfree.com/merchants/signup?source-action=accelerated%20onboarding&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "growth/cross-border-for-exporters",
  "https://merchant.cashfree.com/merchants/signup?referrer=partner&refCode=CFPSL972619",
);
CreateAccountCtaMap.set(
  "international-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=International%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "affiliate-program",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=Affiliate%20Program%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "how-to-choose-the-right-payment-stack-for-optimal-subscription-management",
  "https://merchant.cashfree.com/merchants/signup?source-action=Ebook%20Subscription%20Management&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "digilocker-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=DigiLocker%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "face-match-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Face%20Match%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "driving-license-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=DL%20Verification%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "geolocation-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=GeoLocation%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "aadhaar-esign",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20eSign&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "passport-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Passport%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "employee-background-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Employee%20Background%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "zoho-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Zoho%20Integration&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "employee-background-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Employee%20Background%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "zoho-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Zoho%20Integration&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "IFSC-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=IFSC%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "gst-search-by-pan",
  "https://merchant.cashfree.com/merchants/signup?source-action=GST%20Search%20by%20PAN&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "accept-international-payments",
  "https://merchant.cashfree.com/merchants/signup?source-action=Accept%20International%20Payments&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "voter-id-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Voter%20ID%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "customer-reward-scheme-terms-and-conditions",
  "https://merchant.cashfree.com/merchants/signup?source-action=CustomerReward%20TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "aadhaar-masking",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20Masking%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "rc-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=RC%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "aadhaar-ocr-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20OCR%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "digital-onboarding",
  "https://merchant.cashfree.com/merchants/signup?source-action=Digital%20Onboarding&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "kyb-solutions",
  "https://merchant.cashfree.com/merchants/signup?source-action=KYB%20Solutions%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "digital-kyc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Digital%20KYC&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "automated-kyc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Automated%20KYC&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "risk-shield-for-payment-disbursal",
  "https://merchant.cashfree.com/merchants/signup?source-action=RiskShield%20Payouts&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "beneficiary-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Beneficiary%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);

CreateAccountCtaMap.set(
  "risk-shield-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=RiskShield%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "checkout-one",
  "https://merchant.cashfree.com/merchants/signup?source-action=CheckOut%20One&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "news-room",
  "https://merchant.cashfree.com/merchants/signup?source-action=News%20Room&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "d2c-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=D2C%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "developer-code-of-conduct",
  "https://merchant.cashfree.com/merchants/signup?source-action=Developer%20Code%20Conduct&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "prefill-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Prefill%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "kyc-studio",
  "https://merchant.cashfree.com/merchants/signup?source-action=KYC%20Studio&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=PG1%20Paid&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "one-click-checkout",
  "https://merchant.cashfree.com/merchants/signup?source-action=OneClick%20festive%20Paid&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "upi-switch",
  "https://merchant.cashfree.com/merchants/signup?source-action=UPI%20Switch&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "name-match-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Name%20Match%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "payment-pages",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20pages&action=Sign%20Up&button-id=StartNow_Navbar",
);
CreateAccountCtaMap.set(
  "ai-native-kyc-stack",
  "https://form.typeform.com/to/UZMh17xa",
);
CreateAccountCtaMap.set(
  "settlement-holidays",
  "https://merchant.cashfree.com/merchants/signup?source-action=Settlement%20Holidays&action=Sign%20Up&button-id=StartNow_Navbar",
);

export default CreateAccountCtaMap;
